import React from "react";

export const Facebook = () => {
  return (
    <div id="facebook" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Seuraa meita facebookissa</h2>
        </div>

        <div id="fb-root"></div>
        <div className="fb-box">
          <div
            className="fb-page"
            data-href="https://www.facebook.com/autokorjaamokoljonen/"
            data-tabs="timeline"
            data-width="700"
            data-height="500"
            data-small-header="true"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="false"
          ></div>
        </div>
      </div>
    </div>
  );
};
